import { notification } from "ant-design-vue";

export const openNotification = (type, description, message = 'Notificação', duration = 5) => {
    notification[type]({
        description: description,
        message: message,
        duration: duration
    });
};